import { cn } from "@/lib/cn";

const variants: Record<string, string> = {
  primary: "tw-border-primary-base !tw-border-t-[transparent]",
  white: "tw-border-white !tw-border-t-[transparent]",
};

export const Spinner = ({
  variant = "primary",
  className = "",
}: {
  variant?: string;
  className?: string;
}) => {
  return (
    <span
      className={cn(
        "tw-size-6 tw-animate-spin-regular tw-rounded-full tw-border-2",
        {
          [variants[variant]]: !!variant,
          [className]: !!className,
        },
      )}
    ></span>
  );
};
